import { render, staticRenderFns } from "./Followers.vue?vue&type=template&id=5bf3abba&scoped=true&"
import script from "./Followers.vue?vue&type=script&lang=js&"
export * from "./Followers.vue?vue&type=script&lang=js&"
import style0 from "./Followers.vue?vue&type=style&index=0&id=5bf3abba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf3abba",
  null
  
)

export default component.exports